module.exports = __webpack_public_path__ + "img/bk-water.92a8d9b1.jpeg";